import escape from "./helpers/escape.js";
import todoContent from "./helpers/todo-content.json";
// thx to https://codepen.io/shshaw/pen/WXMdwE
console.clear();

escape("menu.html");

const button = document.querySelector(".demo-button");
const todoList = document.querySelector(".demo-todo-list");
const tplTodo = document.querySelector("template.template-todo");
let indexCounter = 0;

const addTodo = (labelText) => {
  // create an element using the contents of the template
  const todo = tplTodo.content.cloneNode(true);
  const todoId = `todo-${indexCounter}`;
  // replace .todo__text with labelText
  todo.querySelector(".todo__text").textContent = labelText;
  todo.querySelector(".todo").id = todoId;

  // // select the first input element in the list
  // const input = getCheckboxes()[0].querySelector("input");
  // // check the input
  // input.checked = true;
  // getCheckboxes()[0].style.transform = "translateY(100%)";

  // prepend the new element to the .demo-checkbox-list
  todoList.append(todo);
  document
    .getElementById(todoId)
    .querySelector(".todo__state")
    .addEventListener("change", (e) => {
      console.log("changed", e);
    });
  // get the height of a todo
  const todos = todoList.querySelectorAll(".todo");
  // reduce the todoList style property --demo-translate-y by on todo height
  todoList.style.setProperty(
    "--demo-translate-y",
    `${(todoList.clientHeight/2) * - 1}px`
  );
  indexCounter++;
  // appendedTodo.classList.add("pre-intro");
};

const handleButtonClick = () => {
  addTodo(todoContent[indexCounter]);
};

const init = () => {
  addTodo(todoContent[indexCounter]);
  // setTimeout(function () {
  //   document
  //     .querySelector('input[type="checkbox"]')
  //     .setAttribute("checked", true);
  // }, 100);
}

init();

button.addEventListener("click", handleButtonClick);

// add eventlistener for spacebar
document.addEventListener("keydown", (e) => {
  if (e.code === "Space") {
    e.preventDefault();
    // select the last todo
    const lastTodo = document.querySelector(".todo:last-child");
    lastTodo.querySelector(".todo__state").checked = true;

    handleButtonClick();
  }
});

// const button = document.querySelector(".demo-button");
// const checkboxList = document.querySelector(".demo-checkbox-list");
// // make a var that is an array of all the .demo-panel elements
// const tplCheckbox = document.querySelector("template.template-checkbox");
// const getCheckboxes = () =>
//   Array.from(checkboxList.querySelectorAll(".demo-checkbox"));
// let counter = 1;

// const handleButtonClick = () => {
//   // create an element using the contents of the template
//   const checkbox = tplCheckbox.content.cloneNode(true);
//   // select the first input element in the list
//   const input = getCheckboxes()[0].querySelector("input");
//   // check the input
//   input.checked = true;
//   getCheckboxes()[0].style.transform = "translateY(100%)";
//   // prepend the new element to the .demo-checkbox-list
//   const appendedCheckBox = checkboxList.prepend(checkbox);
//   console.log(appendedCheckBox);
//   // appendedCheckBox.classList.add("pre-intro");
// };

// button.addEventListener("click", handleButtonClick);
// // add eventlistener for spacebar
// document.addEventListener("keydown", (e) => {
//   if (e.code === "Space") {
//     e.preventDefault();
//     handleButtonClick();
//   }
// });

